
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatbotConfig, User } from '@shared/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { AdminService } from '@shared-angular/services/admin.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-transfer-bot-modal',
  imports: [FormsModule, ButtonModule, SelectModule, DialogModule],
  templateUrl: './transfer-bot-modal.component.html',
  styleUrl: './transfer-bot-modal.component.css'
})
export class TransferBotModalComponent {
  public bot!: ChatbotConfig;
  public users!: User<string, string>[];
  public selectedUser: string = '';

  constructor(private adminService: AdminService, public bsModalRef: BsModalRef, private toastr: ToastrService) { }

  public async transferBot() {
    const selectedUser = this.users.find(u => u._id == this.selectedUser);
    if (selectedUser) {
      await this.adminService.updateBotField(this.bot._id, 'creatorName', selectedUser.name);
      await this.adminService.updateBotField(this.bot._id, 'creator', selectedUser._id);
      this.toastr.success('SAVED');
    }
  }
}
